module.exports = __webpack_public_path__ + "img/icon_map_5_off_010.cba6305a.png";